import React from 'react';

import {Box, Divider, List, ListItem, Typography} from '@material-ui/core';
import {ISupplierAnalytics} from 'constants/interfaces';

export type EngagementListData = {
  nameKey: string;
  nameTitle: string;
  valueKey: string;
  valueTitle: string;
  items: Array<Record<string, unknown>>;
};
export function AnalyticsEngagementList(props: {data: EngagementListData}) {
  const noData = props.data.items.length == 0;
  if (noData)
    return (
      <Box>
        <Typography variant={'body2'} color={'textSecondary'}>
          No data available
        </Typography>
      </Box>
    );
  return (
    <List disablePadding style={{overflowY: 'scroll', height: '100%'}}>
      <ListItem button>
        <Typography variant={'body2'} style={{width: '2rem'}}></Typography>
        <Typography variant={'body2'} style={{flex: 2}}>
          {props.data.nameTitle}
        </Typography>
        <Typography variant={'body2'} style={{flex: 1}} align={'right'}>
          {props.data.valueTitle}
        </Typography>
      </ListItem>
      <Divider />
      {props.data.items.map((item, index) => (
        <>
          <ListItem button key={index}>
            <Typography variant={'caption'} style={{width: '2rem'}}>
              {index + 1}
            </Typography>
            <Typography variant={'caption'} style={{flex: 2}}>
              {String(item[props.data.nameKey] ?? '')}
            </Typography>
            <Typography variant={'body2'} style={{flex: 1}} align={'right'}>
              {String(item[props.data.valueKey] ?? '')}
            </Typography>
          </ListItem>
          <Divider key={100 + index} />
        </>
      ))}
    </List>
  );
}

export const toTopProductsData = (
  stats: ISupplierAnalytics,
): EngagementListData => ({
  nameKey: 'name',
  nameTitle: 'Product',
  valueKey: 'numberOfViews',
  valueTitle: 'Views',
  items: stats.mostPopular.map((item) => ({
    ...item,
    ...item.product,
  })),
});
